import apiService from './api';
import { 
  DataSheet, 
  CreateDataSheetData, 
  UpdateDataSheetData, 
  DataSheetItem,
  CreateDataSheetItemData,
  UpdateDataSheetItemData 
} from '../types/dataSheetTypes';

class DataSheetService {
  // Data Sheet Operations
  async getDataSheets(): Promise<DataSheet[]> {
    const response = await apiService.get<DataSheet[]>('/data-sheets');
    return response.data;
  }

  async getDataSheet(id: string): Promise<DataSheet> {
    const response = await apiService.get<DataSheet>(`/data-sheets/${id}`);
    return response.data;
  }

  async createDataSheet(data: CreateDataSheetData): Promise<DataSheet> {
    const response = await apiService.post<DataSheet>('/data-sheets', data);
    return response.data;
  }

  async updateDataSheet(data: UpdateDataSheetData): Promise<DataSheet> {
    const response = await apiService.put<DataSheet>(`/data-sheets/${data.id}`, data);
    return response.data;
  }

  async deleteDataSheet(id: string): Promise<void> {
    await apiService.delete(`/data-sheets/${id}`);
  }

  // Data Sheet Items Operations
  async getDataSheetItems(dataSheetId: string): Promise<DataSheetItem[]> {
    const response = await apiService.get<{status: boolean, data: DataSheetItem[]}>(`/data-sheets/${dataSheetId}/items`);
    return response.data.data;
  }

  async addDataSheetItem(dataSheetId: string, data: CreateDataSheetItemData): Promise<DataSheetItem> {
    const response = await apiService.post<{status: boolean, data: DataSheetItem}>(`/data-sheets/${dataSheetId}/items`, data);
    return response.data.data;
  }

  async updateDataSheetItem(dataSheetId: string, itemId: string, data: UpdateDataSheetItemData): Promise<DataSheetItem> {
    const response = await apiService.put<{status: boolean, data: DataSheetItem}>(`/data-sheets/${dataSheetId}/items/${itemId}`, data);
    return response.data.data;
  }

  async deleteDataSheetItem(dataSheetId: string, itemId: string): Promise<void> {
    await apiService.delete(`/data-sheets/${dataSheetId}/items/${itemId}`);
  }
}

export const dataSheetService = new DataSheetService();
export default dataSheetService; 